import React, { FC } from 'react'
import {
  Chip,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from '@mui/material'
import format from 'date-fns/format'
import { useUserPromptResponsesRequest } from 'src/hooks/api'
import { DataLoad, InnerLink } from 'src/components/ui'

interface UserPromptResponseListProps {
  userId: number;
}

export const UserPromptResponseList: FC<UserPromptResponseListProps> = ({ userId }) => {
  const { isInitialLoading, isError, error, data } = useUserPromptResponsesRequest({ userId })
  const responses = data || []

  return (
    <DataLoad isLoading={isInitialLoading} isError={isError} errorMessage={error?.message || ''}>
      {responses.length === 0 ? (
        <Typography sx={{ p: 2 }}>This user has not responded to any prompts.</Typography>
      ) : (
        <TableContainer component={Paper} variant="outlined">
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Prompt</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Selected options</TableCell>
                <TableCell>Responded at</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {responses.map((response) => (
                <TableRow key={response.id}>
                  <TableCell>
                    {response.prompt ? (
                      <InnerLink to={`/prompts/${response.prompt.id}`}>{response.prompt.title}</InnerLink>
                    ) : (
                      `#${response.promptId}`
                    )}
                  </TableCell>
                  <TableCell>
                    <Chip
                      size="small"
                      label={response.status}
                      color={response.status === 'answered' ? 'success' : 'default'}
                    />
                  </TableCell>
                  <TableCell>
                    {response.answers && response.answers.length
                      ? response.answers
                          .filter((answer) => answer.value)
                          .map((answer) => answer.label)
                          .join(', ') || 'None selected'
                      : '—'}
                  </TableCell>
                  <TableCell>
                    {response.respondedAt ? format(new Date(response.respondedAt), 'MMM d, yyyy HH:mm') : ''}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </DataLoad>
  )
}
